import sendQuery from './send-query';

export default async (metaobject_id) => {
  try {
    const query = `
      query getMetaObject {
        metaobject(id: "gid://shopify/Metaobject/${metaobject_id}") {
          id
          handle
      
          fields {
            key
            value
            type
          }
      
          fields {
            key
            value
            type
          }
        }
      }
    `;

    const response = await sendQuery(query);

    if (!response.ok) {
      // throw new Error(`HTTP error ${response.status}`);
      console.log(`HTTP error ${response.status}`);
      return null;
    }

    const response_json = await response.json();

    if (typeof response_json.errors !== 'undefined') {
      console.log('[Storefront API] Error in response:', response_json.errors);
      return null;
    }

    if (typeof response_json.data === 'undefined') {
      console.log('[Storefront API] No data', response_json);
      return null;
    }

    console.log('Storefront API data for metaobject', response_json.data);

    return response_json.data.metaobject.fields[0];
  } catch (error) {
    console.log('[Storefront API]', error);
    return null;
  }
};
